import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "back",
  "use": "back-usage",
  "viewBox": "0 0 6 10",
  "content": "<symbol viewBox=\"0 0 6 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"back\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 1.175L4.8583 0L-1.31881e-07 5L4.8583 10L6 8.825L2.2915 5L6 1.175Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol